import { Repository, EntityRepository } from 'typeorm';
import { Asn } from '../asn.entity';


@EntityRepository(Asn)
export class AsnRepository extends Repository<Asn>{

 
    
}
